webpackJsonp([26],{

/***/ "R/OW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_guarantee_report_form__ = __webpack_require__("uSc8");




new __WEBPACK_IMPORTED_MODULE_0__utils_guarantee_report_form__["a" /* default */]();

/***/ }),

/***/ "ZwpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GusService = function () {
    function GusService() {
        _classCallCheck(this, GusService);
    }

    _createClass(GusService, null, [{
        key: "getDataByNip",
        value: function getDataByNip(url, nip) {
            return $.ajax({
                url: url,
                method: "post",
                data: { nip: nip },
                dataType: "json"
            });
        }
    }]);

    return GusService;
}();

/* harmony default export */ __webpack_exports__["a"] = (GusService);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "uSc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gus_service__ = __webpack_require__("ZwpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__("yEhc");


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var GuaranteeReportForm = function () {
    function GuaranteeReportForm() {
        _classCallCheck(this, GuaranteeReportForm);

        this.form = '#guarante-report-create-form';
        this.formBlock = '#form-block';
        this.two_year_button = '#two_year_guarantee';
        this.three_year_button = '#three_year_guarantee';
        this.five_year_button = '#five_year_guarantee';
        this.submitButton = '#guarantee_report_form_submit';
        this.modalAcceptRulesButton = '#modal-accept-rules-button';
        this.nip = '#guarantee_report_form_nip';
        this.nipIsFromGUS = '#guarantee_report_form_nipIsFromGUS';
        this.companyName = '#guarantee_report_form_companyName';
        this.companyCity = '#guarantee_report_form_companyAddress_city';
        this.companyStreet = '#guarantee_report_form_companyAddress_street';
        this.companyNumberBuilding = '#guarantee_report_form_companyAddress_buildingNumber';
        this.companyNumberLocal = '#guarantee_report_form_companyAddress_apartmentNumber';
        this.companyPostCode = '#guarantee_report_form_companyAddress_postCode';
        this.companyPostCity = '#guarantee_report_form_companyAddress_post';
        this.formNoGuaranteeBlock = '#no-guarantee-block';
        this.guaranteeTypeDropdown = '#guarantee_report_form_guaranteeType';
        this.captcha = '#guarantee_report_form_captcha';
        this.deviceAddressCheckbox = "#guarantee_report_form_anotherDeviceAddress";
        this.acceptRodoCheckbox = "#guarantee_report_form_acceptedProcessingOfPersonalData";

        this.onChangeDeviceAddressCheckbox($(this.deviceAddressCheckbox));

        this.rodoButtonClick();
        this.onLoad();
        this.setUpListeners();
    }

    _createClass(GuaranteeReportForm, [{
        key: "onLoad",
        value: function onLoad() {
            this.onClickKafel($(this.guaranteeTypeDropdown).val());
            this.blockInputIfNipFromGus();
        }
    }, {
        key: "setUpListeners",
        value: function setUpListeners() {
            var _this = this;

            $(document).on('click', this.two_year_button, function () {
                _this.onClickKafel(0);
            });
            $(document).on('click', this.three_year_button, function () {
                _this.onClickKafel(1);
            });
            $(document).on('click', this.five_year_button, function () {
                _this.onClickKafel(2);
            });
            $(document).on('click', this.submitButton, function () {
                event.preventDefault();
            });
            $(document).on('click', this.modalAcceptRulesButton, function () {
                $(_this.captcha).val(grecaptcha.getResponse());
                $(_this.form).submit();
                $('#modal').modal('toggle');
            });
            $(document).on('change', this.acceptRodoCheckbox, function () {
                _this.rodoButtonClick();
            });
            $(document).on('change', this.deviceAddressCheckbox, function (event) {
                _this.onChangeDeviceAddressCheckbox(event.target);
            });
            $(document).on('change', this.nip, function () {
                if (_this.isNipIsFromGus()) {
                    $(_this.nipIsFromGUS).attr('checked', false);
                    _this.changeReadOnlyStatus(false);
                }
                if (__WEBPACK_IMPORTED_MODULE_1__validators__["a" /* default */].nip($(_this.nip).val())) {
                    _this.getDataFromGusAjax();
                }
            });
        }
    }, {
        key: "onClickKafel",
        value: function onClickKafel(id) {
            $(".kafle .active_checkbox").removeClass('active_checkbox');
            $(this.guaranteeTypeDropdown).val(id);
            if (id == 0) {
                $(this.two_year_button).addClass('active_checkbox');
            } else if (id == 1) {
                $(this.three_year_button).addClass('active_checkbox');
            } else if (id == 2) {
                $(this.five_year_button).addClass('active_checkbox');
            }
            this.checkGuaranteeYears();
        }
    }, {
        key: "getDataFromGusAjax",
        value: function getDataFromGusAjax() {
            var self = this;
            var url = $(this.nip).data('gusurl');
            __WEBPACK_IMPORTED_MODULE_0__gus_service__["a" /* default */].getDataByNip(url, $(self.nip).val()).done(function (data) {
                self.setDataFromGusApi(data);
                self.changeReadOnlyStatus(true);
                $(self.nipIsFromGUS).attr('checked', true);
            }).fail(function () {
                self.changeReadOnlyStatus(false);
                $(self.nipIsFromGUS).attr('checked', false);
            });
        }
    }, {
        key: "setDataFromGusApi",
        value: function setDataFromGusApi(data) {
            $(this.companyName).val(data.companyName);
            $(this.companyCity).val(data.companyCity);
            $(this.companyStreet).val(data.companyStreet);
            $(this.companyNumberBuilding).val(data.companyNumberBuilding);
            $(this.companyNumberLocal).val(data.companyNumberLocal);
            $(this.companyPostCode).val(data.companyPostCode);
            $(this.companyPostCity).val(data.companyPostCity);
        }
    }, {
        key: "changeReadOnlyStatus",
        value: function changeReadOnlyStatus(status) {
            $(this.companyName).attr('readonly', status);
            $(this.companyCity).attr('readonly', status);
            $(this.companyStreet).attr('readonly', status);
            $(this.companyNumberBuilding).attr('readonly', status);
            $(this.companyNumberLocal).attr('readonly', status);
            $(this.companyPostCode).attr('readonly', status);
            $(this.companyPostCity).attr('readonly', status);
        }
    }, {
        key: "blockInputIfNipFromGus",
        value: function blockInputIfNipFromGus() {
            if (this.isNipIsFromGus()) {
                this.changeReadOnlyStatus(true);
            }
        }
    }, {
        key: "isNipIsFromGus",
        value: function isNipIsFromGus() {
            return $(this.nipIsFromGUS).is(':checked');
        }
    }, {
        key: "checkGuaranteeYears",
        value: function checkGuaranteeYears() {
            if (this.isFourYearGuarantee()) {
                $(this.formBlock).hide();
                $(this.formNoGuaranteeBlock).show();
            } else {
                $(this.formBlock).show();
                $(this.formNoGuaranteeBlock).hide();
            }
        }
    }, {
        key: "onChangeDeviceAddressCheckbox",
        value: function onChangeDeviceAddressCheckbox(element) {
            var value = $(element).is(":checked");
            if (value === true) {
                $('#device_address_section').removeClass('d-none');
                this.setFlagDisableForDeviceAddress(false);
            } else {
                this.setFlagDisableForDeviceAddress('disabled');
                $('#device_address_section').addClass('d-none');
            }
        }
    }, {
        key: "setFlagDisableForDeviceAddress",
        value: function setFlagDisableForDeviceAddress(isDisabled) {
            if (isDisabled === 'disabled') {
                this.setValueOfDeviceDataWithValue('value', "");
            }
            this.setValueOfDeviceDataWithValue('readonly', isDisabled);
        }
    }, {
        key: "setValueOfDeviceDataWithValue",
        value: function setValueOfDeviceDataWithValue(property, value) {
            $('#guarantee_report_form_deviceAddress_city').prop(property, value);
            $('#guarantee_report_form_deviceAddress_street').prop(property, value);
            $('#guarantee_report_form_deviceAddress_buildingNumber').prop(property, value);
            $('#guarantee_report_form_deviceAddress_apartmentNumber').prop(property, value);
            $('#guarantee_report_form_deviceAddress_postCode').prop(property, value);
            $('#guarantee_report_form_deviceAddress_post').prop(property, value);
            $('#guarantee_report_form_deviceProvince').prop(property, value);
        }
    }, {
        key: "isFourYearGuarantee",
        value: function isFourYearGuarantee() {
            return $(this.guaranteeTypeDropdown).val() == 2;
        }
    }, {
        key: "rodoButtonClick",
        value: function rodoButtonClick() {
            var isChecked = $(this.acceptRodoCheckbox).is(":checked");
            var value = isChecked ? "" : "disabled";
            this.setClickableSubmitButton(value);
        }
    }, {
        key: "setClickableSubmitButton",
        value: function setClickableSubmitButton(value) {
            $('#guarantee_report_form_submit').prop('disabled', value);
        }
    }]);

    return GuaranteeReportForm;
}();

/* harmony default export */ __webpack_exports__["a"] = (GuaranteeReportForm);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "yEhc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validators = function () {
    function Validators() {
        _classCallCheck(this, Validators);
    }

    _createClass(Validators, null, [{
        key: "nip",
        value: function nip(_nip) {
            var nipWithoutDashes = _nip.replace(/-/g, "");
            var reg = /^[0-9]{10}$/;
            if (reg.test(nipWithoutDashes) == false) {
                return false;
            } else {
                var digits = ("" + nipWithoutDashes).split("");
                var checksum = (6 * parseInt(digits[0]) + 5 * parseInt(digits[1]) + 7 * parseInt(digits[2]) + 2 * parseInt(digits[3]) + 3 * parseInt(digits[4]) + 4 * parseInt(digits[5]) + 5 * parseInt(digits[6]) + 6 * parseInt(digits[7]) + 7 * parseInt(digits[8])) % 11;

                return parseInt(digits[9]) == checksum;
            }
        }
    }]);

    return Validators;
}();

/* harmony default export */ __webpack_exports__["a"] = (Validators);

/***/ })

},["R/OW"]);


// WEBPACK FOOTER //
// js/guarantee-report-create.f960ac06.js